import React, { useMemo } from 'react'

const PAD = 2

const Sparkline = ({ points, up = true, width = 100, height = 32 }) => {
  const color = up ? '#34d399' : '#f87171'

  const geo = useMemo(() => {
    if (!Array.isArray(points) || points.length < 2) return null

    const min = Math.min(...points)
    const max = Math.max(...points)
    const step = (width - PAD * 2) / (points.length - 1)

    const coords = points.map((p, i) => {
      const x = PAD + i * step
      const y =
        max === min
          ? height / 2
          : PAD + (height - PAD * 2) * (1 - (p - min) / (max - min))
      return [x, y]
    })

    const line = coords
      .map(([x, y], i) => `${i ? 'L' : 'M'}${x.toFixed(1)} ${y.toFixed(1)}`)
      .join(' ')

    const last = coords[coords.length - 1]
    const first = coords[0]
    const area = `${line} L${last[0].toFixed(1)} ${height} L${first[0].toFixed(1)} ${height} Z`

    return { line, area }
  }, [points, width, height])

  if (!geo) {
    return (
      <svg className='mk-spark' width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
        <line
          x1={PAD}
          y1={height / 2}
          x2={width - PAD}
          y2={height / 2}
          stroke='rgba(255,255,255,0.15)'
          strokeWidth='1.5'
          strokeDasharray='3 3'
        />
      </svg>
    )
  }

  return (
    <svg className='mk-spark' width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <path d={geo.area} fill={color} fillOpacity='0.1' />
      <path
        d={geo.line}
        fill='none'
        stroke={color}
        strokeWidth='1.6'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default React.memo(Sparkline)